<ion-header>
    <ion-toolbar class="ion-padding-end">
        <!-- <ion-title>Menus</ion-title> -->

        <ion-button style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end" (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>

    </ion-toolbar>
</ion-header>
<ion-content class="ion-no-padding">

    <ion-grid [class.preview-image]="FileFormat!='pdf'">

        <ion-row>

            <ng-container [ngSwitch]="FileFormat">

                <ng-container *ngSwitchCase="'pdf'">

                    <object [data]="FileUrl|security:'resourceUrl'" type="application/pdf" width="100%">
                        <source [src]="FileUrl|security:'resourceUrl'" type="application/pdf" />
                        <p>O seu navegador não suporta PDFs. <a [href]="FileUrl">Clique aqui para abrir.</a></p>
                    </object>

                </ng-container>

                <ng-container *ngSwitchDefault>

                    <ion-col size="12">
                        <div #imageWrapper class="image-wrapper">
                            <img *ngIf="FileUrl" [src]="FileUrl"
                                [style.transform]="'translate(' + translateX + 'px,' + translateY + 'px) ' + 'scale(' + zoom + ') ' +  'rotate(' + rotation + 'deg)'"
                                (mousedown)="StartDrag($event)" (mousemove)="OnDrag($event)" (mouseup)="EndDrag()"
                                (mouseleave)="EndDrag()" (wheel)="OnWheel($event)" />
                        </div>
                    </ion-col>

                    <ion-col size="12" class="controls ion-text-center ion-padding-top">

                        <!-- Zoom Out -->
                        <ion-button (click)="ZoomOut()">
                            <ion-icon name="remove-outline" slot="icon-only"></ion-icon>
                        </ion-button>

                        <!-- Zoom In -->
                        <ion-button (click)="ZoomIn()">
                            <ion-icon name="add-outline" slot="icon-only"></ion-icon>
                        </ion-button>

                        <ion-button (click)="Rotate(-90)">
                            <ion-icon name="refresh-outline" slot="icon-only" style="transform: scaleX(-1)"></ion-icon>
                        </ion-button>

                        <ion-button (click)="Reset()">
                            <ion-icon name="contract-outline" slot="icon-only"></ion-icon>
                        </ion-button>

                        <ion-button (click)="Rotate(90)">
                            <ion-icon name="refresh-outline" slot="icon-only"></ion-icon>
                        </ion-button>
                    </ion-col>

                </ng-container>
            </ng-container>

        </ion-row>

    </ion-grid>
</ion-content>